import { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";

import {
  getPresaleTimeLeft,
  hasPresaleCountdownEnded,
} from "../../utils/presaleCountdown";
import "./Modal.css";

const COUNTDOWN_PARTS = [
  ["days", "D"],
  ["hours", "H"],
  ["minutes", "M"],
  ["seconds", "S"],
];

const PresaleFloatingBar = ({ onParticipate }) => {
  const [timeLeft, setTimeLeft] = useState(getPresaleTimeLeft);
  const countdownEnded = hasPresaleCountdownEnded(timeLeft);

  useEffect(() => {
    const timer = window.setInterval(
      () => setTimeLeft(getPresaleTimeLeft()),
      1_000,
    );

    return () => window.clearInterval(timer);
  }, []);

  return (
    <aside
      className="presale-floating-bar"
      aria-label="Presale status and countdown"
    >
      <div className="presale-floating-bar__status">
        <span aria-hidden="true" />
        <div>
          <small>1EYE announcement</small>
          <strong>{countdownEnded ? "Presale Update" : "Presale Live"}</strong>
        </div>
      </div>

      <div
        className="presale-floating-bar__countdown"
        aria-label="Presale time remaining"
      >
        {COUNTDOWN_PARTS.map(([key, label]) => (
          <div key={key}>
            <strong>{timeLeft[key]}</strong>
            <small>{label}</small>
          </div>
        ))}
      </div>

      <button type="button" onClick={onParticipate}>
        {countdownEnded ? "View Presale" : "Buy Now"}
        <FaArrowRight aria-hidden="true" />
      </button>
    </aside>
  );
};

export default PresaleFloatingBar;
